import { FC } from 'react';

export const ArrowUpSmall: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 18C12.5523 18 13 17.5523 13 17V9.41421L16.2929 12.7071C16.6834 13.0976 17.3166 13.0976 17.7071 12.7071C18.0976 12.3166 18.0976 11.6834 17.7071 11.2929L12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6C11.7348 6 11.4804 6.10536 11.2929 6.29289L6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071C6.68342 13.0976 7.31658 13.0976 7.70711 12.7071L11 9.41421V17C11 17.5523 11.4477 18 12 18Z"
			fill="currentColor"
		/>
	</svg>
);
